import * as React from "react"

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import { Link, useLocation } from "react-router-dom"
import { data } from "@/constants/sidebar"
import { useQueryParams } from "@/hooks/use-query-params"
import { usePermissions } from "@/providers/permission-provider"
import { isLinkActive } from "@/utils/sidebar"

export const PortalMiddleSidebarMenu = () => {
  const { hasPermission } = usePermissions()
  const { toggleSidebar, isMobile } = useSidebar()
  const location = useLocation()
  const pathname = location.pathname
  const queryParams = useQueryParams()

  const brokerId = queryParams.brokerId
  const handleToggleSidebar = () => {
    if (isMobile) {
      toggleSidebar()
    }
  }

  return (
    <SidebarMenu>
      {data.sidebarLinks.map((link) => {
        if (!hasPermission(link.permissionRoles)) {
          return null
        }

        const getUrlWithBrokerId = () => {
          if (!brokerId) return link.href

          const separator = link.href.includes("?")
            ? "&"
            : "?"
          return `${link.href}${separator}brokerId=${brokerId}`
        }

        return (
          <SidebarMenu key={link.href}>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                tooltip={link.tooltip}
                isActive={isLinkActive(
                  link.href,
                  link.mainPath,
                  pathname
                )}
                onClick={() => {
                  handleToggleSidebar()
                }}
              >
                <Link to={getUrlWithBrokerId()}>
                  <link.icon />
                  <span>{link.label}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        )
      })}
    </SidebarMenu>
  )
}
